import React, { useRef, useState } from "react";
import {
  FileUploadContainer,
  FormField,
  DragDropText,
  UploadFileBtn,
  FilePreviewContainer,
  ImagePreview,
  PreviewContainer,
  PreviewList,
  FileMetaData,
  RemoveFileIcon,
  InputLabel
} from "./file-upload.styles";

import delete_icon from '../../assets/images/delete-icon.jpeg'

const KILO_BYTES_PER_BYTE = 50000;
const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 50000000;

const convertNestedObjectToArray = (nestedObj) =>
  Object.keys(nestedObj).map((key) => nestedObj[key]);

const convertBytesToKB = (bytes) => Math.round(bytes / KILO_BYTES_PER_BYTE);

const FileUpload = ({
  label,
  updateFilesCb,
  maxFileSizeInBytes = DEFAULT_MAX_FILE_SIZE_IN_BYTES,
  previewSize,
  isEducation,
  fileName,
  setApplicationDetails,
  applicationDetails,
  savedFile,
  handleRemoveItem,
  downloadFile,
  loaderFile,
  files,
  setFiles,
  hide,
  zIndex,
  showFileModel,
  ...otherProps
}) => {
  const fileInputField = useRef(null);
  // const [files, setFiles] = useState({});
  const [hasUploaded, setHasUploaded] = useState(true)


  const handleUploadBtnClick = () => {
    fileInputField.current.click();
  };



  const addNewFiles = (newFiles) => {
    for (let file of newFiles) {
      if (file.size <= maxFileSizeInBytes) {
        setHasUploaded(false)
        if (!otherProps.multiple) {
          return { file };
        }
        files[file.name] = file;
      }else{
      setHasUploaded(true)
        showFileModel(true)
        console.log("do the magic here")
      }
    }
    return { ...files };
  };

  const callUpdateFilesCb = (files) => {
    const filesAsArray = convertNestedObjectToArray(files);
    updateFilesCb(filesAsArray);
  };

  const handleNewFileUpload = (e) => {
    const { files: newFiles } = e.target;
    if (newFiles.length) {
      let updatedFiles = addNewFiles(newFiles);
      setFiles(updatedFiles);
      callUpdateFilesCb(updatedFiles);
    }
    // setHasUploaded(false)
  };

  const removeFile = (fileName) => {
    delete files[fileName];
    setFiles({ ...files });
    callUpdateFilesCb({ ...files });
  };


  return (
    <>
    {savedFile?.fileText === undefined  && hasUploaded || savedFile?.fileText === ''  ?   <FileUploadContainer isEducation={isEducation}>
        <InputLabel className="general-span-text-none-auto">{label}</InputLabel>
        {!isEducation && <DragDropText hide={hide}>Drag and drop your files here or</DragDropText>}
        <UploadFileBtn type="button" onClick={handleUploadBtnClick} zIndex={zIndex}>
          <i className="fas fa-file-upload" />
          <span> Upload {otherProps.multiple ? "file" : "a file"}</span>
        </UploadFileBtn>
        <FormField
          type="file"
          ref={fileInputField}
          onChange={handleNewFileUpload}
          title=""
          value=""
          {...otherProps}
        />
      </FileUploadContainer> : null
      }
  { savedFile?.fileText !== '' && savedFile?.fileText !== undefined  && hasUploaded ?  <div style={{
            width: '100%',
            backgroundColor: '#ccc',
            display: 'flex',
            justifyContent: 'space-between',
            margin: '5px 0px 5px 5px',
            padding: 5}}>
            <span>
              {savedFile?.name}
            </span>
            <a 
              onClick={downloadFile} 
              style={{
                cursor: 'pointer',
                fontWeight: loaderFile ? '' : 'bold',
                color: loaderFile ? '' : 'black'
            }}
              >{loaderFile? 'downloading...' : 'download'}</a>
            <img 
              onClick={()=>handleRemoveItem()}
              src={delete_icon} 
              style={{width: 30, height: 30, cursor: 'pointer'}}
              />
          </div> : null
    }
      {Object.keys(files).map((fileName, index) => {
        return(
          <div style={{
            width: '100%',
            backgroundColor: '#ccc',
            display: 'flex',
            justifyContent: 'space-between',
            margin: '5px 0px',
            padding: 5}}>
            <span>
              {fileName}
            </span>
            <img 
              onClick={()=>{removeFile(fileName); setHasUploaded(true) }}
              src={delete_icon} 
              style={{width: 30, height: 30, cursor: 'pointer'}}
              />
          </div>
        )})}
    </>
  );
};

export default FileUpload;
